module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style-2",
    attrs: {
      "id": "hryeintroduction"
    }
  }, [_c('p', {
    staticClass: "chapter-head",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Among the countless subjects that make up the lore and legend of the Civil War there is perhaps none more iconic than the myth and mystery surrounding the Confederate battle cry—the famous Rebel Yell.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The iconic nature of the Yell has led to its being hijacked for commercial purposes for everything from a line of casual clothing and a brand of Kentucky bourbon, to a famous rock anthem, as well as many other uses.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The most obvious statement that can be made about the Rebel Yell is that no one alive today truly knows how it sounded. While there have been numerous attempts to duplicate it—some quite well done—by re-enactors, filmmakers and others, it still remains, at best, an educated guess based on available evidence. The reliability of that evidence varies considerably depending upon its source and nature.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The sources range from writers, historians and others over the last seventy-five years or so, to first hand accounts from soldiers at the time, as well as recollections from veterans years later. There is even a small amount of recorded sound evidence that is extremely enticing at the very least.—The nature of the evidence ranges from the apocryphal and/or anecdotal to the descriptive and the phonetic. There is also a considerable amount of information concerning background, origin and variation.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The intent of this book is to present as much of the available evidence as possible in an orderly, readable and enjoyable manner; and to then sort through the accumulated material and draw some conclusions.")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("I will be acting as a “guide” to the reader as we search for, and investigate, the Rebel Yell, which admittedly gives me the opportunity to insert some of my own thoughts and interpretations about any specific subject being looked at during our investigation. Hopefully this will help “lighten the load” a bit, because the most important thing for readers of history is to enjoy themselves, while digging a little deeper into a subject than they have in the past….So relax, take a deep breath and get ready to Yell!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425d5bb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Introduction.vue
// module id = 75
// module chunks = 0